import Validator from "./validator";

class Converter {
  static centsToDollarsWithoutRounding(cents, roundPosition) {
    const defaultRoundPosition = 2;

    if (Validator.isNil(cents) || cents === "N/A") {
      return "N/A";
    }

    if (!Validator.isUndefined(roundPosition) && Validator.isInteger(roundPosition)) {
      return !isNaN(cents) ? (cents / 100).toFixed(roundPosition) : NaN;
    } else {
      return !isNaN(cents) ? (cents / 100).toFixed(defaultRoundPosition) : NaN;
    }
  }
}

export default Converter;



// WEBPACK FOOTER //
// ./src/helpers/converter.js